import type { NextPage, GetServerSideProps } from 'next'
import Image from 'next/image'
import SystemInfoImage from './assets/history.jpg'
import H2 from './H2'
import H3 from './H3'
import styles from './about.module.css'

interface IProps {

}

const Component: NextPage<IProps> = ({ }) => {
  return (
    <div className='flex flex-col items-center'>
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex flex-col items-center justify-center'>
        <div className={`${styles.doc} 'w-full my-12'`}>
          <H2 className='mt-16'>
            제도 안내
          </H2>

          <H3 prefix='가.' className='mt-12 mb-8'>환경영향평가</H3>

          <p className='my-8'>
            환경영향평가는 환경영향평가 대상사업의 사업계획을 수립하려고 할 때 그 사업의 시행이 환경에 미치는 영향을 미리 조사·예측·평가하여 해로운 환경영향을 피하거나 줄이는 방안을 마련하는 제도입니다.
          </p>
          <p className='my-8'>
            이는 각종 개발사업의 시행으로 인한 환경파괴와 환경오염을 사전에 방지하기 위한 정책 수단으로 활용되며, 환경적으로 건전하고 지속가능한 개발을 유도하여 쾌적한 환경을 유지·조성하는 데 목적을 두고 있습니다.
          </p>
          <p className='my-8'>
            우리나라는 지난 &apos;77년 「환경보전법」에 환경영향평가를 도입한 이래 그간 여러 번의 법령 개정을 거쳐 현 제도를 안정적으로 운영하고 있으며 국가에서 「환경영향평가법」에 따라 운영하는 환경영향평가는 “택지개발사업 30만 제곱미터 이상” 등 대규모 사업에 대하여 실시하고 소규모 사업일지라도 지역 특성과 해당 지역의 환경 민감성 및 입지 조건 등에 따라 환경에 영향을 미칠 수 있는 사업은 지방자치단체의 조례로 환경영향평가를 실시하도록 규정하고 있습니다.
          </p>

          <div className='my-8'>
            <Image src={SystemInfoImage} alt='환경영향평가제도' />
          </div>

          <H3 prefix='나.' className="mt-12 mb-8">시·도 조례에 따른 환경영향평가</H3>

          <p className='my-6'>
            경기도는 개발과 보존이 공존하는 지속가능한 경기도를 만들기 위해 &apos;도 조례에 따른 환경영향평가&apos;를 2019년 7월 16일 제정, 2020년 1월 1일부터 시행하고 있습니다.
          </p>

          <table className={styles.table}>
            <thead>
              <tr>
                <th rowSpan={2}>구분</th>
                <th colSpan={5}>시</th>
                <th colSpan={5}>도</th>
              </tr>
              <tr>
                <th>서울</th>
                <th>인천</th>
                <th>부산</th>
                <th>대전</th>
                <th>광주</th>
                <th>강원</th>
                <th>제주</th>
                <th>경남</th>
                <th className={styles.point}>경기</th>
                <th>전북</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>최초<br/>시행일</td>
                <td>2002</td>
                <td>2002</td>
                <td>2003</td>
                <td>2004</td>
                <td>2007</td>
                <td>2003</td>
                <td>2006</td>
                <td>2006</td>
                <td className={styles.point}>2020</td>
                <td>2021</td>
              </tr>
            </tbody>
          </table>

          <p className='mt-6'>
            「경기도 환경영향평가 조례」에 따른 환경영향평가 대상사업은 법령상에서 규정하는 평가 대상사업* 과 지역적 특성을 고려하여 영향평가가 필요하다고 판단된 사업**으로 총 3개 분야 17개 사업입니다.
          </p>
          <p className='mt-2 mb-16 text-[#176CE3] !text-[18px]'>
            * 「환경영향평가법 시행령 [별표3]에 따른 대상사업의 50%이상 100%미만인 규모의 사업
            <br />
            ** 도시환경문제를 유발할 우려가 있는 대형건물, 고형연료제품(SRF) 발전소 건립에 따른 환경문제 발생으로 추가 지정
          </p>


        </div>
      </div>
    </div>
  )
}

export default Component
